/**
 * Route for `day-wise-invoice-grouping`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DayWiseInvoiceGroupingPage } from "../features/day-wise-invoice-grouping/DayWiseInvoiceGroupingPage";

export const dayWiseInvoiceGroupingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/day-wise-invoice-grouping",
	component: DayWiseInvoiceGroupingPage,
});

export default dayWiseInvoiceGroupingRoute;
